/**
 * Detect whether a tab was pressed first to trigger a special accessible layout
 * @type {boolean}
 */

let firstMouseInteractionRegistered = false;

document.addEventListener('click', function mouseTriggered() {
    firstMouseInteractionRegistered = true;
});

document.onkeydown = function () {
    if (window.event.keyCode === "undefined") {
        return;
    }
    if (!firstMouseInteractionRegistered && window.event.keyCode === 9) {
        document.body.classList.add('tab-optimized');
    }
};

/**
 * Fade in page when loaded
 */
document.addEventListener('DOMContentLoaded', function() {
    // Remove opaque once page has loaded
    document.body.classList.remove('opaque');
});
